import { LdtFakeAppRepository } from '@ldt/api/fake_app_repository';
import { LdtFakeMemberRepository } from '@ldt/api/fake_member_repository';
import { LdtFakeOrderRepository } from '@ldt/api/fake_order_repository';
import { LdtGraphqlAppRepository } from '@ldt/api/graphql_app_repository';
import { LdtGraphqlOrderRepository } from '@ldt/api/graphql_order_repository';
import { LdtOrderRepository } from '@ldt/api/order_repository';
import { LdtProstateOrderDetailDisplayer } from '@ldt/features/orders';
import { AppRepository } from 'src/api/app_repository';
import { GraphqlClient } from 'src/api/graphql_client';
import { MemberRepository } from 'src/api/member_repository';
import { OrderDetailDisplayer } from 'src/distribution_platforms/features/order_details';
import {
  InstanceFactory,
  BaseInstanceFactory,
} from 'src/distribution_platforms/features/utils/base_instance_factory';
import { Region, RepoBackend } from 'src/types/env';
import { GraphqlClientRequiredError } from 'src/types/errors';

/**
 * Instance factory for the LDT platform.
 */
export class LdtInstanceFactory
  extends BaseInstanceFactory
  implements InstanceFactory
{
  constructor(readonly _repoBackend: RepoBackend) {
    super(_repoBackend);
  }

  createAppRepository(graphqlClient: GraphqlClient): AppRepository {
    if (this._repoBackend === RepoBackend.Fake) {
      return new LdtFakeAppRepository();
    } else if (this._repoBackend === RepoBackend.Real) {
      if (!graphqlClient) {
        throw new GraphqlClientRequiredError();
      }
      return new LdtGraphqlAppRepository(graphqlClient!);
    }

    throw new Error(`Invalid repository ${this._repoBackend}`);
  }

  createOrderRepository(
    _region: Region,
    graphqlClient?: GraphqlClient,
  ): LdtOrderRepository {
    if (this._repoBackend === RepoBackend.Fake) {
      return new LdtFakeOrderRepository();
    } else if (this._repoBackend === RepoBackend.Real) {
      if (!graphqlClient) {
        throw new GraphqlClientRequiredError();
      }
      return new LdtGraphqlOrderRepository(graphqlClient!);
    }

    throw new Error(`Invalid repository ${this._repoBackend}`);
  }

  createMemberRepository(graphqlClient?: GraphqlClient): MemberRepository {
    if (this._repoBackend === RepoBackend.Fake) {
      return new LdtFakeMemberRepository();
    } else if (this._repoBackend === RepoBackend.Real) {
      if (!graphqlClient) {
        throw new GraphqlClientRequiredError();
      }
      return super.createMemberRepository(graphqlClient);
    }

    throw new Error(`Invalid repository ${this._repoBackend}`);
  }

  createProstateBiopsyOrderDetailDisplayer(
    orderRepository: LdtOrderRepository,
  ): OrderDetailDisplayer {
    return new LdtProstateOrderDetailDisplayer(orderRepository);
  }
}
